import { render, staticRenderFns } from "./VideoSidePanel.vue?vue&type=template&id=69fdbb04"
import script from "./VideoSidePanel.vue?vue&type=script&lang=js"
export * from "./VideoSidePanel.vue?vue&type=script&lang=js"
import style0 from "./VideoSidePanel.vue?vue&type=style&index=0&id=69fdbb04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports